import secureLocalStorage from "react-secure-storage";
import { TENANT_NAME_STORAGE } from "./storageConfig";



export function storageSelectedTenantSave(tenantName: string) {
    secureLocalStorage.setItem(TENANT_NAME_STORAGE, tenantName)
}


export function storageSelectedTenantGet(): string {
    return secureLocalStorage.getItem(TENANT_NAME_STORAGE) as string
}

export function storageSelectedTenantRemove() {
    secureLocalStorage.removeItem(TENANT_NAME_STORAGE)
}
